export default __webpack_public_path__ + "static/media/suitcase.12cbbfd7.svg";